import { useCallback, useContext } from 'react';
import { FiscalPeriodsContext } from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider';
import getFiscalEntitiesFromInterval from '../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/FiscalPeriodsProvider/getFiscalEntitiesFromInterval';
import { DateTime } from 'luxon';

const getFiscalEntityByDate = (
  date: string,
  interval: FixedPeriods.FiscalType,
  allFiscals: FixedPeriods.AllFiscals,
) => {
  const entities = getFiscalEntitiesFromInterval(interval, allFiscals);
  const dateAsISO = DateTime.fromISO(date).toISODate();
  const entityIndex = entities?.findIndex(
    (e) => e.startDate <= dateAsISO && e.endDate >= dateAsISO,
  );

  if (!entityIndex || !entities) {
    return;
  }

  return entities[entityIndex];
};

const useIsSameFiscalYear = () => {
  const { allFiscals } = useContext(FiscalPeriodsContext);

  const isSameFiscalYear = useCallback(
    (startDate: string, endDate: string, interval: FixedPeriods.FiscalType) => {
      if (!allFiscals) {
        return false;
      }

      // // If start date and end date are in separate fiscal years, last year comparison is incompatible
      const rangeStartPeriod = getFiscalEntityByDate(
        startDate,
        interval,
        allFiscals,
      );
      const rangeEndPeriod = getFiscalEntityByDate(
        endDate,
        interval,
        allFiscals,
      );

      if (!rangeStartPeriod || !rangeEndPeriod) {
        return false;
      }

      return rangeStartPeriod.currentYear === rangeEndPeriod.currentYear;
    },
    [allFiscals],
  );

  return isSameFiscalYear;
};

export default useIsSameFiscalYear;
